// extracted by mini-css-extract-plugin
export var Article = "style-module--Article--a4577";
export var BackArrow = "style-module--BackArrow--f76ce";
export var Banner = "style-module--Banner--cbdac";
export var BannerCaption = "style-module--BannerCaption--55184";
export var BannerImage = "style-module--BannerImage--71c8d";
export var Body = "style-module--Body--9dac7";
export var Breadcrumb = "style-module--Breadcrumb--15487";
export var Category = "style-module--Category--d42a1";
export var Content = "style-module--Content--a6403";
export var Details = "style-module--Details--92676";
export var Footer = "style-module--Footer--d408f";
export var Header = "style-module--Header--1fafc";
export var Keyword = "style-module--Keyword--9a2c3";
export var ReadingTime = "style-module--ReadingTime--45206";